import React from "react";
import styled from "styled-components";

const ProjectSelector = ({ projects, value, onChange, accent = "#7069FD" }) => (
  <Select value={value || ""} onChange={(e) => onChange(Number(e.target.value))} $accent={accent}>
    {projects.map((p) => (
      <option key={p.id} value={p.id}>{p.name}</option>
    ))}
  </Select>
);

const Select = styled.select`
  appearance: none;
  padding: 5px 26px 5px 10px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 7px;
  border: 1px solid ${({ $accent }) => `${$accent}40`};
  color: ${({ $accent }) => $accent};
  background-color: ${({ $accent }) => `${$accent}0F`};
  background-image: ${({ $accent }) => `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='10' viewBox='0 0 24 24' fill='none' stroke='%23${$accent.slice(1)}' stroke-width='2.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E")`};
  background-repeat: no-repeat;
  background-position: right 8px center;
  cursor: pointer;
  outline: none;
  max-width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: border-color 0.15s, background-color 0.15s;

  &:focus {
    border-color: ${({ $accent }) => `${$accent}80`};
    background-color: ${({ $accent }) => `${$accent}1A`};
  }
`;

export default ProjectSelector;
